<template>
  <div v-if="props.banners.length > 0" class="position-relative text-center" style="background-color: #19B7CA;">
    <template v-for="(banner, index) in props.banners" :key="banner.id">
      <span v-if="index > 0" class="text-white px-1" aria-hidden="true">|</span>
      <router-link v-if="banner.linkType === BannerLinkTypeEnum.Vimeo && banner.videoKey" :to="{ name: 'vimeo-video', params: { videoKey: banner.videoKey }, query: { title: banner.videoTitle } }" target="_blank" rel="noopener noreferrer" class="text-white fw-bold link-underline link-underline-opacity-0">
        <em>{{ banner.text }} <i class="fa-regular fa-play-circle text-danger ms-2"></i></em>
      </router-link>
      <a v-else-if="banner.linkType === BannerLinkTypeEnum.Link && banner.link" :href="banner.link" target="_blank" rel="noopener noreferrer" class="text-white fw-bold link-underline link-underline-opacity-0">
        <em>{{ banner.text }}</em>
      </a>
      <em v-else class="text-white fw-bold">{{ banner.text }}</em>
    </template>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  banners: UserBanner[]
}>()

</script>
